import { faThumbsDown, faThumbsUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  Button,
  ButtonGroup,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from '@mui/material';
import type { FieldValues } from 'react-hook-form';

import {
  TICKET_FEEDBACK_REASONS,
  TICKET_TYPE
} from '@/pages/Ticket/Ticket.constants';

import type { TicketFeedbackRatingProps } from './TicketFeedbackRating.types';

const TicketFeedbackRating = <T extends FieldValues = FieldValues>({
  field,
  feedbackReason,
  formFeedbackRating,
  ticketType
}: TicketFeedbackRatingProps<T>) => {
  return (
    <>
      <Box sx={{ mt: 2 }}>
        <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
          Please rate your support experience (Optional)
        </Typography>
        <ButtonGroup>
          <Button
            variant={formFeedbackRating === 1 ? 'contained' : 'outlined'}
            onClick={() => {
              field.onChange(1);
              if (feedbackReason) {
                feedbackReason.field.onChange(undefined);
              }
            }}
            startIcon={<FontAwesomeIcon icon={faThumbsUp} />}
            sx={{
              width: '6.5rem',
              color: formFeedbackRating === 1 ? 'common.white' : 'primary.main'
            }}
          >
            Good
          </Button>

          <Button
            variant={formFeedbackRating === -1 ? 'contained' : 'outlined'}
            onClick={() => field.onChange(-1)}
            startIcon={<FontAwesomeIcon icon={faThumbsDown} />}
            sx={{
              color: formFeedbackRating === -1 ? 'common.white' : 'primary.main'
            }}
          >
            Not Good
          </Button>
        </ButtonGroup>
      </Box>
      {formFeedbackRating === -1 &&
        feedbackReason &&
        ticketType !== TICKET_TYPE.SERVICE && (
          <Box sx={{ mt: 2 }}>
            <InputLabel>Reason</InputLabel>
            <FormControl sx={{ minWidth: '20rem' }}>
              <Select
                {...feedbackReason.field}
                value={feedbackReason.field.value || ''}
              >
                {TICKET_FEEDBACK_REASONS.map((reason) => (
                  <MenuItem key={reason.id} value={reason.text}>
                    {reason.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
    </>
  );
};

export default TicketFeedbackRating;
